var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from "clsx";
import React, { createContext, forwardRef, useContext, useRef, useState, } from "react";
import { AccordionContext } from "./AccordionContext";
import { omit } from "../util";
export const AccordionItemContext = createContext(null);
const AccordionItem = forwardRef((_a, ref) => {
    var { children, className, open, defaultOpen = false } = _a, rest = __rest(_a, ["children", "className", "open", "defaultOpen"]);
    const [internalOpen, setInternalOpen] = useState(defaultOpen);
    const context = useContext(AccordionContext);
    const [_open, _setOpen] = useState(defaultOpen);
    const shouldAnimate = useRef(!(Boolean(open) || defaultOpen));
    const handleOpen = () => {
        if (open === undefined) {
            const newOpen = !_open;
            _setOpen(newOpen);
            setInternalOpen(newOpen);
        }
        else {
            setInternalOpen(!open);
        }
        shouldAnimate.current = true;
    };
    if (!(context === null || context === void 0 ? void 0 : context.mounted)) {
        console.error("<Accordion.Item> has to be used within an <Accordion>");
    }
    return (React.createElement("div", Object.assign({ className: cl("navds-accordion__item", className, {
            "navds-accordion__item--open": open !== null && open !== void 0 ? open : internalOpen,
            "navds-accordion__item--neutral": (context === null || context === void 0 ? void 0 : context.variant) === "neutral",
            "navds-accordion__item--no-animation": !shouldAnimate.current,
        }), ref: ref }, omit(rest, ["onClick"])),
        React.createElement(AccordionItemContext.Provider, { value: {
                open: open !== null && open !== void 0 ? open : internalOpen,
                toggleOpen: handleOpen,
            } }, children)));
});
export default AccordionItem;
//# sourceMappingURL=AccordionItem.js.map